import React, { useMemo } from 'react';
import useTranslation from '~/app/hooks/useTranslation';
import Icon from '~/app/common/Icon';
import classes from './style.module.scss';

export interface CommentProps {
    comment: string;
}

export type CommentComponent = React.FC<CommentProps>;

const Comment: CommentComponent = ({ comment }) => {
    const { t } = useTranslation('workorder');

    const commentText = useMemo(() => comment?.trim() ?? '', [comment]);

    return (
        <div className={classes['card']}>
            <div className={classes['header']}>
                <h2 className={classes['header-title']}>
                    <Icon name="forum" size={20} className={classes['header-icon']} />
                    {t('detail.comments')}
                </h2>
                {false && <button type="button" className={classes['edit-btn']} aria-label={t('detail.edit')}>
                    <Icon name="edit" size={16} />
                    {t('detail.edit')}
                </button>}
            </div>
            {commentText ? (
                <div className={classes['comment-block']}>
                    <p className={classes['comment-text']}>{commentText}</p>
                </div>
            ) : (
                <p className={classes['empty']}>{t('detail.noComment')}</p>
            )}
        </div>
    );
};

export default Comment;
